<template>
  <div
    class="relative flex flex-col w-full font-regular p-4 text-gray-900 bg-white rounded-lg shadow-xl shadow-blue-gray-900/5 bg-clip-border dark:bg-gray-800 dark:text-gray-200"
  >
    <!-- Header Section -->
    <h3
      class="block text-xl antialiased font-medium leading-snug tracking-normal mb-6 dark:text-gray-200"
    >
      Setup Video Guide
    </h3>

    <!-- Colorful SVG Section -->
    <div class="h-full w-full flex justify-center items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 400 400"
        class="w-full h-full max-w-[400px]"
        aria-labelledby="video-guide-title"
      >
        <title id="video-guide-title">Setup Video Guide Illustration</title>
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #6a11cb; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #2575fc; stop-opacity: 1" />
          </linearGradient>
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #ff7e5f; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #feb47b; stop-opacity: 1" />
          </linearGradient>
        </defs>
        <rect width="400" height="400" fill="url(#gradient1)" rx="20" />
        <circle cx="200" cy="200" r="100" fill="url(#gradient2)" />
        <path
          d="M160 140v120l100-60z"
          fill="#fff"
          transform="translate(0, 0)"
          class="hover:scale-110 transition-transform duration-300"
        />
        <text
          x="50%"
          y="90%"
          text-anchor="middle"
          fill="#fff"
          font-size="20"
          font-weight="bold"
          class="dark:fill-gray-200"
        >
          Watch Now
        </text>
      </svg>
    </div>

    <!-- Call-to-Action Button -->
    <router-link to="/learning-page" class="mt-6">
      <button
        class="w-full flex justify-center items-center gap-2 py-3 px-6 bg-main-500 text-white rounded-lg hover:bg-main-600 transition-colors duration-300 dark:bg-main-600 dark:hover:bg-main-700"
      >
        <i class="fa-solid fa-play text-[16px]"></i>
        Explore Video Guides
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "VideoGuideAid",
};
</script>
